import { SVGProps, memo } from 'react';

const SvgLoginIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 91 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.362 66.421a2 2 0 0 0 3.567 1.811l-3.567-1.81Zm26.611-14.334v-2 2Zm23.045 16.145a2 2 0 0 0 3.567-1.81l-3.567 1.81Zm-52.235-9.1a2 2 0 0 0-3.33 2.215l3.33-2.215Zm-2.776-41.898a2 2 0 1 0 3.274 2.299l-3.274-2.299Zm-2.69 10.355a2 2 0 1 0-2.83 2.828l2.83-2.828Zm7.867 10.696 1.414 1.414a2 2 0 0 0 0-2.829l-1.414 1.415Zm-10.696 7.867a2 2 0 0 0 2.828 2.828l-2.828-2.828ZM2.902 36.597a2 2 0 0 0 0 4v-4Zm17 4a2 2 0 1 0 0-4v4Zm44.536-3.967c0 7.439-6.03 13.47-13.47 13.47v4c9.649 0 17.47-7.822 17.47-17.47h-4ZM50.968 50.1C43.53 50.1 37.5 44.068 37.5 36.63h-4c0 9.648 7.822 17.47 17.47 17.47v-4ZM37.5 36.63c0-7.439 6.03-13.47 13.47-13.47v-4c-9.648 0-17.47 7.822-17.47 17.47h4Zm13.47-13.47c7.438 0 13.469 6.031 13.469 13.47h4c0-9.648-7.821-17.47-17.47-17.47v4Zm-23.04 45.072a25.844 25.844 0 0 1 9.525-10.326l-2.093-3.41a29.846 29.846 0 0 0-10.999 11.925l3.567 1.811Zm9.525-10.326a25.844 25.844 0 0 1 13.52-3.819v-4a29.844 29.844 0 0 0-15.613 4.41l2.093 3.409Zm13.52-3.819c4.772 0 9.452 1.322 13.52 3.819l2.092-3.41a29.844 29.844 0 0 0-15.613-4.409v4Zm13.52 3.819a25.844 25.844 0 0 1 9.524 10.326l3.567-1.81a29.844 29.844 0 0 0-11-11.926l-2.092 3.41Zm-46.042 3.441A39.095 39.095 0 0 0 37.66 76.443l1.365-3.76a35.095 35.095 0 0 1-17.242-13.551l-3.33 2.215ZM37.66 76.443a39.096 39.096 0 0 0 24.418.748l-1.133-3.837a35.095 35.095 0 0 1-21.92-.67l-1.365 3.76Zm24.418.748a39.095 39.095 0 0 0 20.095-13.894l-3.19-2.415a35.095 35.095 0 0 1-18.038 12.472l1.133 3.837Zm20.095-13.894a39.096 39.096 0 0 0 7.924-23.109l-4-.05a35.094 35.094 0 0 1-7.113 20.744l3.189 2.415Zm7.924-23.109a39.095 39.095 0 0 0-7.341-23.3l-3.249 2.333a35.095 35.095 0 0 1 6.59 20.917l4 .05Zm-7.341-23.3A39.094 39.094 0 0 0 63.017 2.492l-1.229 3.806a35.095 35.095 0 0 1 17.72 12.922l3.248-2.334ZM63.017 2.492a39.095 39.095 0 0 0-24.43.133l1.271 3.793a35.095 35.095 0 0 1 21.93-.12l1.23-3.806Zm-24.43.133a39.095 39.095 0 0 0-19.58 14.608l3.274 2.299A35.095 35.095 0 0 1 39.858 6.419l-1.27-3.793Zm-25.1 27.791L22.77 39.7l2.829-2.829-9.282-9.281-2.828 2.828Zm9.282 6.453-9.281 9.282 2.828 2.828 9.282-9.281-2.829-2.829ZM2.902 40.597h17v-4h-17v4Z"
      fill="url(#loginIcon_svg__a)"
    />
    <defs>
      <linearGradient
        id="loginIcon_svg__a"
        x1={92.705}
        y1={80.239}
        x2={41.111}
        y2={-39.454}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3451B2" />
        <stop offset={1} stopColor="#BB45FF" />
      </linearGradient>
    </defs>
  </svg>
);

const Memo = memo(SvgLoginIcon);
export default Memo;
